import { Sprite, Text, TextStyle } from "pixi.js";
import { CheckoutPiggyResourcePackage } from "../resources/CheckoutPiggyResourcePackage";
import { GameFont } from "../../../common/GameFont";

export class CheckoutPiggyHeaderComponent extends Sprite {
    private static readonly INNER_TEXT = 'TO YOUR NEWLY MINTED';

    private readonly innerText: Text;

    public constructor(introResources: CheckoutPiggyResourcePackage) {
        super(introResources.assets_views_piggy_intro_welcome_png);
        this.innerText = new Text(CheckoutPiggyHeaderComponent.INNER_TEXT, new InnerTextTextStyle());
        this.innerText.skew.x = -0.08;
        this.innerText.angle = -5.67;
        this.innerText.position.set(103, 155);
        this.addChild(this.innerText);
    }
}

class InnerTextTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fill: 'FFFFFF',
            fontSize: 56
        });
    }
}